import { Component, Element, h, Host, Prop } from "@stencil/core";
import { ListVariant } from "./list-variant.enum";

@Component({
    tag: "ux-list",
    shadow: true,
    styleUrl: "list.scss"
})
export class List {
    /**
     * Represents the variant of the list.
     */
    @Prop() readonly variant: keyof typeof ListVariant | ListVariant = ListVariant.Default;

    @Element() uxListElement!: HTMLUxListElement;

    private validateChildNodes() {
        // @ts-expect-error Check for typing
        const slottedElements = this.uxListElement.shadowRoot.querySelector("slot").assignedNodes();
        if (slottedElements.some((i) => i.nodeName !== "UX-LIST-ITEM" && i.nodeName !== "#text")) {
            throw Error("Invalid component detected: Please ensure only 'ux-list-item' components are inserted into this slot.");
        }
    }

    public render() {
        return (
            <Host variant={this.variant}>
                <ul>
                    <slot onSlotchange={() => this.validateChildNodes()} />
                </ul>
            </Host>
        );
    }
}
